import $ from "jquery";

const subscription = () => {
    $(".subscription__option").on("click", function () {
        // Remove the 'active' class from all options and add it to the clicked one
        $(".subscription__option").removeClass("active");
        $(this).addClass("active");

        // Get the index of the clicked option
        const index = $(".subscription__option").index(this);

        // Hide all subscription cards and show the one corresponding to the index
        $(".subscription__card").addClass("hidden");
        $(".subscription__card").eq(index).removeClass("hidden");
    });
};

export default subscription;